export default __webpack_public_path__ + "static/media/Topics_Icon (1).ec41a40b.svg";